<template>
  <b-navbar class="ControlNav" fixed="top">
    <div class="container">
      <b-navbar-nav>
        <b-nav-item :class="[{ active: onAccountTab}, 'control-nav-item']" to="/account">
          <span class="hide-mobile">Account </span>Home<span class="nav-info">Settings, Billing, Contacts</span>
        </b-nav-item>

        <b-nav-item :class="[{ disabled: true, active: onServicesTab }, 'control-nav-item']" to="/services">
          Services<span class="nav-info">Servers, Hosting, etc.</span>
        </b-nav-item>

        <b-nav-item :class="[{ disabled: !hasPaymentsViewPerm, active: onBillingTab }, 'control-nav-item']" to="/billing">
          Billing<span class="nav-info">Payments, Statements</span>
        </b-nav-item>
      </b-navbar-nav>
      <b-navbar-nav>
        <b-nav-item @click="logout" :class="['CtrLogout', 'control-logout']" right>
          <b-icon-box-arrow-right font-scale="1.25" id="logout-icon" class="hide-mobile"/><span class="nav-info logout-button-span">Log Out</span>
        </b-nav-item>
      </b-navbar-nav>
    </div>
  </b-navbar>
</template>

<script>
  import { mapGetters } from 'vuex'
  import {BNavbar, BNavItem, BNavbarBrand, BNavbarToggle, BCollapse, BNavbarNav, BIconBoxArrowRight } from 'bootstrap-vue'

  export default {
    data () {
      return {
        servicesNav: [
          { param: 'connectivity', label: 'Connectivity' },
          { param: 'emails', label: 'Email' },
          { param: 'servers', label: 'Servers' },
          { param: 'hosting', label: 'Hosting' },
          { param: 'domains', label: 'Domains' },
          { param: 'dnspanel', label: 'DNS' },
          { param: 'colocations', label: 'Colocation' },
          { param: 'ssl', label: 'SSL' },
          { param: 'voip', label: 'VoIP' }
        ]
      }
    },

    computed: {
      hasRouteName () {
        return 'name' in this.$store.state.route && this.$store.state.route.name !== undefined
      },
      onAccountTab () {
        return this.hasRouteName && ['account'].includes(this.$store.state.route.name)
      },
      onAdminTab () {
        return this.hasRouteName && ['admin'].includes(this.$store.state.route.name)
      },
      onServicesTab () {
        return this.hasRouteName && ['services', 'servicesParam', 'manage-server', 'server', 'ssl', 'domain_redirects'].includes(this.$store.state.route.name)
      },
      onBillingTab () {
        return this.hasRouteName && ['billing', 'payment', 'invoice'].includes(this.$store.state.route.name)
      },
      ...mapGetters([
        'hasPaymentsViewPerm',
        'hasServicesViewPerm',
        'isSiteAdmin'
      ])
    },

    methods: {
      logout () {
        this.$store.dispatch('logout', this.$router)
      }
    },

    components: {
      BNavbar,
      BNavItem,
      BNavbarBrand,
      BNavbarToggle,
      BCollapse,
      BNavbarNav,
      BIconBoxArrowRight
    }
  }
</script>

<style scoped>

.ControlNav {
  background:#ddd;  border:none;
  top:71px;
  height:50px;
  padding-top: 0;
  padding-bottom: 0;
  z-index:10;
}


.ControlNav a, .CtrLogout a {
  text-align:center;
  line-height:normal;
  color:#666;
}

.ControlNav .nav-info {font-size:11px; display:block; opacity:0.8}
.ControlNav .router-link-active {color:#111; background:#fff}

.CtrLogout:hover {cursor:pointer; color:black}

.control-nav-item:hover { background-color: #f2f2f2; }
.control-logout:hover {color: black; cursor: pointer;}

.ControlNav + div.container {padding-top:120px}

.navbar-toggle {margin:2px 0 0 0 !important}

.nav-link {
  height: 50px;
}

.container {padding-right: 15px; padding-left: 15px;}

@media (max-width: 767px) {
  .ControlNav .nav-info {display:none;}
  .logout-button-span {display:block !important; font-size:14px !important; white-space: nowrap;}
  .hide-mobile {display:none}
  .container {padding-right: 0px; padding-left: 0px;}
}




.darkMode .ControlNav .nav-link {color:#fff; background-color:#1C1F22; }
.darkMode .navbar {background-color: #1C1F22;}
.darkMode .ControlNav .router-link-active {color:#fff; background:#0f1113;}
.darkMode .ControlNav .nav-link:hover { background-color: #22262b; }


</style>



// WEBPACK FOOTER //
// BottomNavbar.vue?59f2c06a